import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const ChangeDueDate = Loadable(
  lazy(() => import("features/changeDueDate/components/ChangeDueDate"))
);

const routes = {
  path: "changeDueDate",
  children: [{ path: "", element: <ChangeDueDate /> }],
};

export default routes;
